import { trpc } from './trpc';
import { inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';

type NotificationListOutput = inferRouterOutputs<AppRouter>['notifications']['list'];
type BackendNotificationItem = NotificationListOutput[number];

type DistributiveOmit<T, K extends keyof any> = T extends unknown ? Omit<T, K> : never;

export type NotificationItem = DistributiveOmit<BackendNotificationItem, 'createdAt'> & { createdAt: number };

export function toNotificationItems(items: NotificationListOutput): NotificationItem[] {
  return items.map((item) => ({ ...item, createdAt: item.createdAt.getTime() }));
}

const NOTIFICATIONS_POLL_INTERVAL_MS = 60_000;

export const useNotifications = () => {
  return trpc.notifications.list.useQuery(
    {},
    { refetchInterval: NOTIFICATIONS_POLL_INTERVAL_MS, select: toNotificationItems },
  );
};

export const useUnreadNotificationsCount = () => {
  return trpc.notifications.unreadCount.useQuery({}, { refetchInterval: NOTIFICATIONS_POLL_INTERVAL_MS });
};

export const useMarkNotificationsRead = () => {
  const utils = trpc.useUtils();

  return trpc.notifications.markRead.useMutation({
    onSuccess: () => {
      utils.notifications.list.invalidate();
      utils.notifications.unreadCount.invalidate();
    },
  });
};
